import { c as _c } from "react/compiler-runtime";
import { works } from '@/data/works';
import ShowcaseLayout from './showcase-layout';
import Container from '@/components/layouts/container';
const Showcase = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Container><ShowcaseLayout works={works} /></Container>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Showcase;